module.exports = __webpack_public_path__ + "redeem_reward_images_mobile.png";